{
	"labels": {
		"trenutni": "Trenutni podpis:",
		"alt": "Podpis še nimate dodan!",
		"buttons": {
			"dodaj": "Dodaj / Zamenjaj svoj podpis",
			"shrani": "Shrani",
			"pocisti": "Počisti"
		}
	}
}